module.exports = __webpack_public_path__ + "img/c01_unithippikon_Normal_ua.e48a9a76.webp";